import * as localSettingsAT from './localSettings/actionTypes'

export const localSettings = localSettingsAT

export const AUTHED = 'AUTH/AUTHED'
export const CHECK_SESSION = 'AUTH/CHECK_SESSION'
export const GET_USER = 'AUTH/GET_USER'
export const GET_USER_FEES = 'AUTH/GET_USER_FEES'
export const GET_USER_LIMITS = 'AUTH/GET_USER_LIMITS'
export const POLL_USER = 'AUTH/POLL_USER'
export const REMOVE_TOTP_CONFIG = 'AUTH/REMOVE_TOTP_CONFIG'
export const SET_EMAIL_VERIFICATION_ID = 'AUTH/SET_EMAIL_VERIFICATION_ID'
export const SET_API_KEYS = 'AUTH/SET_API_KEYS'
export const SET_API_KEY_DEACTIVATE = 'AUTH/SET_API_KEY_DEACTIVATE'
export const SET_DEVICE_INFO = 'AUTH/SET_DEVICE_INFO'
export const SET_FILL_RECEIPT_PREFERENCE = 'AUTH/SET_FILL_RECEIPT_PREFERENCE'
export const SET_NEW_API_KEY_CREDENTIALS = 'AUTH/SET_NEW_API_KEY_CREDENTIALS'
export const SET_REFERRER_USERNAME = 'AUTH/SET_REFERRER_USERNAME'
export const SET_SESSION = 'AUTH/SET_SESSION'
export const SET_SOCKET_AUTHED = 'AUTH/SET_SOCKET_AUTHED'
export const SET_TOTP_CONFIG = 'AUTH/SET_TOTP_CONFIG'
export const SET_TWO_FACTOR_STATUS = 'AUTH/SET_TWO_FACTOR_STATUS'
export const SET_USER = 'AUTH/SET_USER'
export const SET_USER_AGGREGATED_FEES = 'AUTH/SET_USER_AGGREGATED_FEES'
export const SET_USER_SETTINGS = 'AUTH/SET_USER_SETTINGS'
export const SET_TIERS_LIMITS_VOLUME = 'AUTH/SET_TIERS_LIMITS_VOLUME'
export const SET_USER_FEES = 'AUTH/SET_USER_FEES'
export const SET_USER_PROMOS = 'AUTH/SET_USER_PROMOS'
export const SIGNOUT = 'AUTH/SIGNOUT'
export const SIGNUP_START = 'AUTH/SIGNUP_START'
export const IS_AUTHING = 'AUTH/IS_AUTHING'
